<template>
  <div>
    <!-- 搜索区 -->
    <search-component @handleQueryData="handelSearch" @handleFilterData="handleFilter" />
    <add-btn  @add="handleAddContract()" />
    <!-- 补充协议列表区 start -->
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="handleContract" v-if="list.length > 0">
      <total-component :totalValue="total" />
      <van-cell v-for="(item,index) in list" :key="index">
        <!-- <div class="flex-c-center" v-if="item"> -->
         <div>
            <div class="custName-wrap">
              <div class="custName">
                <van-icon name="bookmark" color="green" />{{ item.custName }}
                <span>
                </span>
              </div>
            </div>
            <div style="color: #1989fa">
              【{{item.businessTypeName}}】
            </div>
            <div>
              <div>
                <van-tag color="#999" style="margin-right: 5px" plain type="primary" v-if="item.templateType">{{ formatHandel('templateType',item.templateType) }}</van-tag>
                <van-tag color="#999" style="margin-right: 5px" plain type="primary" v-if="item.payType">{{ formatHandel('payType',item.payType) }}</van-tag>
                <van-tag color="#999" style="margin-right: 5px" plain type="primary" v-if="item.frameType">{{ formatHandel('frameType',item.frameType) }}</van-tag>
                <van-tag color="#999" plain type="primary" v-if="item.custSource">{{ formatHandel('custSource',item.custSource) }}</van-tag>
              </div>
              <div style="color: #07c160; font-size: 12px">合同金额(元)：{{item.contractMoney}} <span style="color: #ff976a;margin-left: 5px">回款金额(元)： {{item.allReturnedMoney}}</span></div>
              <div style="color: #999; font-size: 12px">{{item.deptName}}<span style="color: #1989fa;margin-left: 5px;margin-right: 5px">{{item.userName}}</span>  {{item.createTime}}</div>
            </div>
            <div class="bottomBtn">
              <van-button round type="primary" size="mini" plain @click="editAgree(item)"><van-icon name="edit" size="14" color="#07c160" />修改</van-button>
              <van-button round color="#ee0a24" size="mini" plain @click="deleteAgree(item)"><van-icon name="delete" size="14" color="#ee0a24" />删除</van-button>
              <van-button round type="info" size="mini" plain v-hasPermi="['cont:newContract:yyApply']" @click="handleYyApply(item)"><van-icon name="sign" size="14" color="#1989fa" />用印申请</van-button>
            </div>
          </div>
          <!-- <van-icon color="#c1c1c1" name="arrow" size="16" class="arrow-color"  @click="toContractDetails(item)" /> -->

        <!-- </div> -->
      </van-cell>
    </van-list>
    <empty-component v-if="isEmpty" />
    <!-- 合同列表区 end -->

    <!--客户搜索-->
    <!-- <search-pop :show.sync="showFilterPop" @handlequery="handleFqueryFilter" /> -->

    <!-- <dialog-cont :show='add_show' :contractType='6' :deptTreeOptions="deptTreeList"   @handleAddContractCancel='handleAddContractCancel' @beforeClose='addContractBeforeClose'></dialog-cont> -->
    <div class="container" v-if="dialogShow">
      <div class="card" >
        <van-dialog v-model="dialogShow" :title="isAdd?'添加补充协议':'修改补充协议'" width="95%" style="height:80%" class="editClue" :beforeClose="beforeClose" show-cancel-button>
          <van-form ref="form" validate-trigger="onSubmit" class="dialog-form-wrap" style="height:98%;">
            <van-collapse v-model="activeNames">
              <van-collapse-item name="0">
                <template #title>
                  <span class="van-collaps-title">合同信息</span>
                </template>
                <div class="list-wrap van-hairline--top">
                  <div class="item" >
                    <span class="key">合同名称：</span>
                    <span class="value">{{ form.contractName }}</span>
                  </div>
                  <div class="item" >
                    <span class="key">合同编号：</span>
                    <span class="value">{{ form.contractNum }}</span>
                  </div>
                  <div class="item" >
                    <span class="key">执行时间：</span>
                    <span class="value">{{ form.startTime }}至{{ form.endTime }}</span>
                  </div>
                  <div class="item" >
                    <span class="key">收款单位：</span>
                    <span class="value">{{form.companyName}}</span>
                  </div>
                  <div class="item" style="width: 48%">
                    <span class="key">垫款方式：</span>
                    <span class="value">{{formatHandel('payType',form.payType)}}</span>
                  </div>
                  <div class="item" style="width: 48%">
                    <span class="key">框架类型：</span>
                    <span class="value">{{formatHandel('frameType',form.frameType)}}</span>
                  </div>
                  <div class="item" style="width: 48%">
                    <span class="key">客户来源：</span>
                    <span class="value">{{formatHandel('custSource',form.custSource)}}</span>
                  </div>
                </div>
              </van-collapse-item>
              <van-collapse-item name="1" class="skzxkh">
                <template #title>
                  <span class="van-collaps-title">补充协议信息</span>
                </template>
                <van-field v-model="form.executionTime" readonly clickable name="calendar" label="执行时间" placeholder="点击选择执行时间" @click="showCalendar('executionTime')" />
                <div style="color: #ee0a24;">注：有效时间的开始时间必须在本协议审核通过之后的时间，原因：消耗API数据实时在运行。</div>
                <van-field v-model="form.contractMoney" label="合同金额" placeholder="请输入合同金额" @blur="getSum('contractMoney')" type="number" maxlength="11" />
                <van-field v-model="form.remark" label="备注" placeholder="请填写备注"  />
                <van-field v-model="form.creditCycleTypeName" label="授信账期类型" placeholder="请选择授信账期类型" readonly clickable  @click="showPicker('creditCycleType')" />
                <van-field v-model="form.creditCycleValue" label="授信账期时间(天)" placeholder="请输入授信账期时间(天)" type="digit" maxlength="5" />
                <van-field v-model="form.advancesMoney" label="垫款金额" placeholder="请输入垫款金额" @blur="getSum('advancesMoney')" />
                <van-field v-model="form.advancesCycle" label="垫款事由" placeholder="请输入垫款事由" />
                <van-button v-if="form.fileList.length == 0" class="topBtn" round block type="primary" native-type="button" size="small" @click="addEnclosure">+增加附件</van-button>
                <van-collapse v-model="activeNamesC">
                  <van-collapse-item :title="'附件'+(index+1)" :name="index" v-for="(item,index) in form.fileList" :key="index+'01'">
                    <!-- <van-field v-model="item.title" label="附件标题" placeholder="请输入附件标题" :rules="[{ required: true }]" required /> -->
                    <!-- <van-field v-model="item.amount" label="变动金额(元)" placeholder="请输入变动金额" @focus="getFocus(index)" @blur="getSum('amount',index)" type="number" maxlength="11" /> -->
                    <van-field v-model="item.fileTypeName" label="附件类型" placeholder="请选择附件类型" readonly clickable  :rules="[{ required: true }]" required />
                    <van-field
                      v-model="item.fileDesc"
                      rows="2"
                      autosize
                      label="附件描述"
                      placeholder="请输入附件描述"
                      type="textarea"
                      show-word-limit
                    />
                    <van-field v-model="item.url" label="其他附件" placeholder="需要上传的文件" readonly @click="getIndex(index)" :rules="[{ required: true }]" required >
                      <template #button>
                        <van-uploader :after-read="uploadContractPictureFiles" :before-read="beforeRead" :max-size="10000 * 1024" @oversize="onOversize" accept="application/pdf,.doc,.docx,">
                          <van-button icon="plus" type="info" size="mini">上传附件</van-button>
                        </van-uploader>
                      </template>
                    </van-field>
                    <div class="attachment_link">
                      <a v-if="item.url" :href="item.url" @click="downloadUrlFile(item.url,item.title + '附件')">{{item.fileName}}    查看附件</a>
                    </div>
                    <!-- <a v-if="item.url" :href="item.url" @click="downloadUrlFile(item.url,item.title + '附件')">查看附件</a> -->
                    <div class="link">
                      <van-button class="linkaddBtn" round block type="primary" native-type="button" size="small" @click="addEnclosure">+增加附件</van-button>
                      <van-button class="linkaddBtn" round block type="warning" native-type="button" size="small" @click="deleteE(index)">删除</van-button>
                    </div>
                  </van-collapse-item>
                </van-collapse>
              </van-collapse-item>
              <van-collapse-item title="合同项目" name="2" class="skzxkh">
                <template #title>
                  <span class="van-collaps-title">合同项目</span>
                </template>
                <!-- <van-field v-model="form.supTime" readonly clickable name="calendar" label="补充协议执行时间" placeholder="点击选择补充协议执行时间" @click="showCalendar('supTime')" :rules="[{ required: true }]" required /> -->

                <van-field v-model="form.mediaLocationName" label="媒体版位" placeholder="请选择媒体版位" readonly clickable @click="showTreeSelect('mediaLocation')" />
                <div v-if="form.mediaLocationNames" class="tagArr">
                  <van-tag v-for="(item,index) in form.mediaLocationNames.split(',')" :key="index" color="#1989fa">{{item}}</van-tag>
                </div>
                <van-field v-model="form.deliveryLinkName" label="投放链路" placeholder="请选择投放链路" readonly clickable @click="showTreeSelect('deliveryLink')" />
                <div v-if="form.deliveryLinkNames" class="tagArr">
                  <van-tag v-for="(item,index) in form.deliveryLinkNames.split(',')" :key="index" color="#1989fa">{{item}}</van-tag>
                </div>
                <van-field v-model="form.openAccountFee" label="开户服务费" placeholder="请输入开户服务费"  @blur="getSum('openAccountFee')" type="number" maxlength="11" />
                <van-field v-model="form.agentBussFee" label="代运营服务费" placeholder="请输入代运营服务费" @blur="getSum('agentBussFee')" type="number" maxlength="11" >
                  <template slot="right-icon">%</template>
                </van-field>
                <van-field v-model="form.materialMoney" label="素材费" placeholder="请输入素材费"  @blur="getSum('materialMoney')" type="number" maxlength="11" />
                <van-button style="margin-top: 10px" v-if="form.pointList.length == 0" class="topBtn" round block type="primary" native-type="button" size="small" @click="addPoint">+增加返点百分比</van-button>
                <van-collapse v-model="activeNamesP">
                  <van-collapse-item :title="'返点'+(index+1)" :name="index" v-for="(item,index) in form.pointList" :key="index+'01'">
                    <van-field v-model="item.percentage" label="返点百分比" placeholder="请输入返点百分比" type="number" >
                      <template slot="right-icon">%</template>
                    </van-field>
                    <van-field v-model="item.useMoney" label="返点消耗" :placeholder="index == 0?'无需输入,阶梯返点请增加返点':'返点消耗'" type="number" maxlength="13" @blur="fixValue(item.useMoney,index)" :disabled="index == 0">
                      <template slot="label">返点消耗<span class="dayuxiaoyufu">{{form.pointList.length > 1?index == 0?'<':'≥':''}}</span></template>
                      <template slot="right-icon">￥</template>
                    </van-field>
                    <van-field v-model="item.zxTime" label="执行时间" placeholder="请选择执行时间" readonly clickable @click="showCalendar('zxTime',index)" />
                    <div class="link">
                      <van-button class="linkaddBtn" round block type="primary" native-type="button" size="small" @click="addPoint">+增加返点</van-button>
                      <van-button class="linkaddBtn" round block type="warning" native-type="button" size="small" @click="deletePoint(index)">删除</van-button>
                    </div>
                  </van-collapse-item>
                </van-collapse>
              </van-collapse-item>
            </van-collapse>
          </van-form>
        </van-dialog>
        <van-calendar v-model="datePicker.showDate" :min-date="datePicker.minDate" :type="datePicker.type" @confirm="dateConfirm" />
        <van-popup v-model="picker.visible" position="bottom">
          <van-picker :loading="picker.loading" :title="picker.title" show-toolbar :columns="picker.columns" @confirm="pickerConfirm" @cancel="pickerCancel" />
        </van-popup>
        <van-popup v-model="mediaSelect" position="bottom">
          <van-tree-select :items="treeItems" :active-id.sync="mediaActiveIds" :main-active-index.sync="treeActiveIndex" @click-item="chooseTree" />
          <van-button block type="info" native-type="button" size="small" @click="mediaSelect = false">完成</van-button>
        </van-popup>
        <van-popup v-model="deliverySelect" position="bottom">
          <van-tree-select :items="treeItems" :active-id.sync="deliveryActiveIds" :main-active-index.sync="treeActiveIndex" @click-item="chooseTree" />
          <van-button block type="info" native-type="button" size="small" @click="deliverySelect = false">完成</van-button>
        </van-popup>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
// import { getContract, delContract, addContract } from '@/api/cont/salecontract'
import { Toast, TreeSelect, Dialog } from 'vant'
import payment from '@/api/cont/payment'
import newContract from '@/api/cont/newContract' // listContract
// import { ucloudUpFileToContract } from '@/api/system/common'
import { getDicts } from '@/api/system/dict/data'
import { CascaderTreeSelect } from '@/api/admi/dept'
import SearchComponent from '@/components/common/Search'
// import ListItem from '../components/contract/ListContractItem.vue'
import EmptyComponent from '@/components/common/Empty'
import TotalComponent from '@/components/common/Total'
// import SearchPop from '../components/contract/SearchPop.vue'
// import DialogCont from '../components/DialogCont.vue'
import AddBtn from '@/components/common/AddBtn'
// import { Toast } from 'vant'
export default {
  components: {
    SearchComponent,
    EmptyComponent,
    TotalComponent,
    // SearchPop,
    AddBtn,
    // DialogCont,
    // ListItem,
    [TreeSelect.name]: TreeSelect,
    [Dialog.Component.name]: Dialog.Component
  },
  filters: {
    timeFormat(val) {
      return moment(val).format('YYYY-MM-DD')
    }
  },
  data() {
    return {
      isEmpty: false,
      add_show: false,
      loading: false,
      finished: false,
      options: {
        // 业务类型树选项
        incomeBankOptions: [],
        contPartnerTypeOptions: [],
        fundTypeOptions: [],
        mediaLocationOptions: [],
        deliveryLinkOptions: [],
        fileTypeOptions: []
      },
      // 部门tree
      deptTreeList: [],
      list: [],
      showFilterPop: false,
      active: 0,
      // 列表
      activeName: 'list_contract',
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        parentId: '',
        isSupCont: 1,
        orderByColumn: 'createTime',
        isAsc: 'desc'
      },
      dialogShow: false,
      picker: {
        visible: false,
        title: '',
        columns: [],
        formKey: '',
        loading: false
      },
      datePicker: {
        showDate: false,
        minDate: new Date(2010, 0, 1),
        type: 'single',
        formKey: ''
      },
      activeNames: ['0', '1', '2'],
      activeNamesP: [0],
      activeNamesC: [0],
      contForm: {},
      mediaSelect: false,
      deliverySelect: false,
      typeTree: '',
      treeActiveIndex: 0,
      mediaActiveIds: [],
      deliveryActiveIds: [],
      treeItems: [],
      form: { pointList: [], fileList: [] },
      isEdit: true,
      oldContractMoney: '',
      fixId: '',
      isAdd: true
    }
  },
  async created() {
    // 合同模板
    await getDicts('template_type').then(res => {
      this.options.templateTypeOptions = res.data
    })
    // 框架类型
    await getDicts('frame_type').then(res => {
      this.options.frameTypeOptions = res.data
    })
    // 垫款方式
    await getDicts('pay_type').then(res => {
      this.options.payTypeOptions = res.data
    })
    // 合同状态
    await getDicts('contract_status').then(res => {
      this.options.contractStatusOptions = res.data
    })
    // 框架类型
    await getDicts('cust_source').then(res => {
      this.options.custSourceOptions = res.data
    })
    // 授信账期类型
    await getDicts('credit_cycle_type').then(res => {
      this.options.creditCycleTypeOptions = res.data
    })
    // 附件类型
    getDicts('file_type').then(res => {
      this.options.fileTypeOptions = res.data
    })
    this.queryParams.parentId = this.$route.query.id
    await this.handleContract()
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      // 修改主体框架标题
      document.title = '补充协议列表'

      // 获取部门信息
      await CascaderTreeSelect().then((response) => {
        this.deptTreeList = response.data
      })
    },
    // 搜索子组件传递过来的搜索关键字
    handelSearch(data) {
      this.resetQuery()
      this.queryParams.contractName = this.searchValue = data
      this.queryContractList()
    },
    // 过滤子组件传递过来的搜索对象
    handleFqueryFilter(data) {
      const query = this.queryParams
      this.queryParams = { ...query, ...data }
      this.queryContractList()
    },
    // 接收子组件的filter事件
    handleFilter() {
      this.showFilterPop = true
    },
    queryContractList() {
      this.list = []
      this.queryParams.pageNum = 1
      this.handleContract()
    },
    toContractDetails(item) {
      this.$router.push({
        path: '/cont/approve/detail',
        query: {
          id: item.contractId
          // verifyStatus: item.verifyStatus,
          // status: 1
        }
      })
    },
    async handleContract() {
      this.loading = true
      const res = await newContract.listContract(this.queryParams)
      if (res.code === 200) {
        if (res.rows.length === 0) {
          this.isEmpty = true
        } else {
          this.isEmpty = false
        }
        this.list = this.list.concat(res.rows)
        this.total = res.total
        this.queryParams.pageNum += 1
        this.loading = false
        this.finished = this.list.length >= res.total
        this.showFilterPop = false
      }
    },
    async handleAddContract() {
      this.isAdd = true
      await newContract.getContract(this.queryParams.parentId).then(res => {
        this.form = res.data
        this.form.fileList = []
        this.oldContractMoney = this.form.contractMoney
        this.form.executionTime = `${this.form.startTime} 至 ${this.form.endTime}`
        this.form.creditCycleTypeName = this.formatHandel('creditCycleType', this.form.creditCycleType)
        this.form.mediaLocationName = this.form.mediaLocationNames
        this.form.deliveryLinkName = this.form.deliveryLinkNames
      })
      await this.getListPoint(this.queryParams.parentId)
      this.dialogShow = true
    },
    async editAgree(item) {
      this.isAdd = false
      this.fixId = item.contractId
      const that = this
      await newContract.getContract(item.contractId).then(res => {
        this.form = res.data
        this.oldContractMoney = this.form.contractMoney
        this.form.executionTime = `${this.form.startTime} 至 ${this.form.endTime}`
        this.form.creditCycleTypeName = this.formatHandel('creditCycleType', this.form.creditCycleType)
        this.form.mediaLocationName = this.form.mediaLocationNames
        this.form.deliveryLinkName = this.form.deliveryLinkNames
        that.form.fileList.forEach(function(value, index, array) {
          that.form.fileList[index].fileTypeName = that.formatHandel('fileType', Number(that.form.fileList[index].fileType))
        })
      })
      await this.getListPoint(item.contractId)
      this.dialogShow = true
    },
    async getListPoint(contractId) {
      const res = await newContract.getRebateList({ contractId: contractId })
      if (res.code === 200) {
        if (res.rows.length != 0) {
          this.form.pointList = res.rows
          this.form.pointList.map(item => {
            item.zxTime = `${item.startTime} 至 ${item.endTime}`
          })
        }
      }
    },
    async deleteAgree(item) {
      Dialog.confirm({
        message: '是否确认删除此条数据'
      })
        .then(() => {
          newContract.deleteContract(item.contractId).then(res => {
            if (res.code === 200) {
              Toast.success('成功删除!')
              setTimeout(() => {
                this.queryContractList()
              }, 500)
            }
          })
        })
        .catch(() => {
        // on cancel
        })
    },
    handleYyApply(item) {
      newContract.getContract(item.contractId).then(response => {
        if (response.data.fileList.length == 0) {
          Toast.fail('请在修改中添加合同附件信息!')
          return
        }
        Dialog.confirm({
          message: '是否进行用印申请'
        })
          .then(() => {
            newContract.yyApply({ contractId: item.contractId }).then(res => {
              if (res.code == 200) {
                Toast.success('用印申请成功!')
                setTimeout(() => {
                  this.queryContractList()
                }, 500)
              }
            })
          })
          .catch(() => {
            // on cancel
          })
      })
    },
    async beforeClose(type, done) {
      if (type === 'confirm') {
        if (this.id) {
          this.form.contractId = this.id
        }
        if (this.form.contractMoney != this.oldContractMoney && !this.form.remark) {
          Toast.fail('请填写备注')
          return done(false)
        }
        try {
          await this.$refs.form.validate()
          if (this.isAdd) {
            this.form.contractId = this.queryParams.parentId
            await payment.addAgreement(this.form)
              .then(() => {
                Toast.success('添加成功')
                this.reset()
                this.dialogShow = false
                setTimeout(() => {
                  this.queryContractList()
                }, 500)
              }).catch(() => {})
            done()
          } else {
            this.form.contractId = this.fixId
            if (this.form.fileList.length > 0) {
              await newContract.addContractFile(this.form.fileList)
            }
            if (this.form.pointList.length > 0) {
              await newContract.addRebate(this.form.pointList, this.form.contractId)
            }
            newContract.updateContract(this.form)
              .then(() => {
                Toast.success('修改成功')
                this.reset()
                this.dialogShow = false
                setTimeout(() => {
                  this.queryContractList()
                }, 500)
              }).catch(() => {})
            done()
          }
        } catch (err) {
          return done(false)
        }
        return done(false)
      } else {
        done()
        this.queryContractList()
      }
    },
    reset() {
      this.form = { pointList: [], fileList: [] }
    },
    // showCalendar(type) {
    //   this.datePicker.formKey = type
    //   if (type === 'executionTime' || type === 'supTime') {
    //     this.datePicker.type = 'range'
    //   } else {
    //     this.datePicker.type = 'single'
    //   }
    //   this.datePicker.showDate = true
    // },
    showCalendar(type, index) {
      if (index || index == 0) {
        this.index = index
      } else {
        this.index = null
      }
      this.datePicker.formKey = type
      if (type === 'executionTime' || type === 'zxTime') {
        this.datePicker.type = 'range'
      } else {
        this.datePicker.type = 'single'
      }
      this.datePicker.showDate = true
    },
    dateConfirm(date) {
      if (this.index || this.index == 0) {
        if (this.datePicker.formKey === 'payTime') {
          this.form.contPayAgreeList[this.index][this.datePicker.formKey] = this.formatDate(date)
        } else if (this.datePicker.formKey === 'zxTime') {
          const [start, end] = date
          this.form.pointList[this.index].startTime = this.formatDate(start)
          this.form.pointList[this.index].endTime = this.formatDate(end)
          this.form.pointList[this.index].zxTime = `${this.formatDate(start)} 至 ${this.formatDate(end)}`
        }
      } else {
        if (this.datePicker.formKey === 'executionTime') {
          const [start, end] = date
          this.form.startTime = this.formatDate(start)
          this.form.endTime = this.formatDate(end)
          this.form.executionTime = `${this.formatDate(start)} 至 ${this.formatDate(end)}`
        } else {
          this.form[this.datePicker.formKey] = this.formatDate(date)
        }
      }
      this.datePicker.showDate = false
      // this.minDate = date
      // if (this.datePicker.formKey === 'executionTime') {
      //   const [start, end] = date
      //   this.form.startTime = this.formatDate(start)
      //   this.form.endTime = this.formatDate(end)
      //   this.form.executionTime = `${this.formatDate(start)} 至 ${this.formatDate(end)}`
      // } else if (this.datePicker.formKey === 'supTime') {
      //   const [start, end] = date
      //   this.form.supStartTime = this.formatDate(start)
      //   this.form.supEndTime = this.formatDate(end)
      //   this.form.supTime = `${this.formatDate(start)} 至 ${this.formatDate(end)}`
      // } else {
      //   this.form[this.datePicker.formKey] = this.formatDate(date)
      // }

      // this.datePicker.showDate = false
    },
    formatDate(date) {
      // 时间格式化 2019-09-08
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      return year + '-' + month + '-' + day
    },
    getSum(val) {
      if (this.form[val] && this.form[val].indexOf('.') != -1) {
        this.form[val] = Number(this.form[val]).toFixed(2)
      }
      // this.amountWords = this.toChineseBig(this.form.contractMoney)
    },
    async showPicker(type) {
      this.picker.loading = true
      this.picker.columns = []
      this.picker.formKey = type
      const optionItem = type + 'Options'
      if (type === '') {

      } else {
        this.picker.columns = this.options[optionItem].map((ele) => ele.dictLabel)
        this.picker.loading = false
      }
      this.picker.visible = true
    },
    async pickerConfirm(value, key) {
      const optionItem = this.picker.formKey + 'Options'
      console.log('key:' + key)
      const name = this.picker.formKey + 'Name'
      if (this.picker.formKey === '') {

      } else {
        this.form[this.picker.formKey] = this.options[optionItem][key].dictValue
        this.form[name] = this.options[optionItem][key].dictLabel
      }
      console.log(this.form)
      this.picker.visible = false
    },
    pickerCancel() {
      this.picker.visible = false
    },
    async showTreeSelect(item) {
      this.typeTree = item
      if (item == 'mediaLocation') {
        this.mediaSelect = true
        this.mediaActiveIds = []
        this.form.mediaLocationNames = ''
        this.form.mediaLocationName = ''
        // console.log(this.mediaActiveIds)
        if (this.options.mediaLocationOptions.length == 0) {
          await newContract.getTreeData({ deliveryLink: 2 }).then(res => {
            this.options.mediaLocationOptions = this.handleTree(res.rows, 'deliveryLinkId')
          })
        }
        this.treeItems = this.options.mediaLocationOptions.map(item => {
          return {
            id: item.deliveryLinkId,
            text: item.deliveryLinkName,
            children: item.children ? item.children.map(item => {
              return {
                id: item.deliveryLinkId,
                text: item.deliveryLinkName,
                disabled: false
              }
            }) : [],
            disabled: false
          }
        })
      } else if (item == 'deliveryLink') {
        this.deliverySelect = true
        this.deliveryActiveIds = []
        this.form.deliveryLinkNames = ''
        this.form.deliveryLinkName = ''
        if (this.options.deliveryLinkOptions.length == 0) {
          await newContract.getTreeData({ deliveryLink: 1 }).then(res => {
            this.options.deliveryLinkOptions = this.handleTree(res.rows, 'deliveryLinkId')
          })
        }
        this.treeItems = this.options.deliveryLinkOptions.map(item => {
          return {
            id: item.deliveryLinkId,
            text: item.deliveryLinkName,
            children: item.children ? item.children.map(item => {
              return {
                id: item.deliveryLinkId,
                text: item.deliveryLinkName,
                disabled: false
              }
            }) : [],
            disabled: false
          }
        })
      }
    },
    chooseTree(data) {
      if (this.typeTree == 'mediaLocation') {
        if (this.mediaActiveIds.length > 0) {
          this.treeItems.map((res, index) => {
            res.disabled = true
            if (this.treeActiveIndex == index) {
              this.treeItems[this.treeActiveIndex].disabled = false
            }
          })
        } else {
          this.treeItems.map((res) => {
            res.disabled = false
          })
        }
        const arr = []
        const arr2 = []
        this.treeItems[this.treeActiveIndex].children.map((res) => {
          if (this.mediaActiveIds.length > 0) {
            this.mediaActiveIds.map((item) => {
              if (res.id == item) {
                arr.push(this.treeItems[this.treeActiveIndex].text + '/' + res.text)
                arr2.push(res.text)
              }
            })
          }
        })
        this.form.mediaLocationIds = this.mediaActiveIds.join(',')
        this.form.mediaLocationNames = arr.join(',')
        this.form.mediaLocationName = arr2.join(',')
      } else if (this.typeTree == 'deliveryLink') {
        const arr = []
        const arr2 = []
        this.treeItems.map(res => {
          res.children.map(item => {
            if (this.deliveryActiveIds.length > 0) {
              this.deliveryActiveIds.map((item2) => {
                if (item.id == item2) {
                  arr.push(res.text + '/' + item.text)
                  arr2.push(item.text)
                }
              })
            }
          })
        })
        this.form.deliveryLinkIds = this.deliveryActiveIds.join(',')
        this.form.deliveryLinkNames = arr.join(',')
        this.form.deliveryLinkName = arr2.join(',')
      }
    },
    getIndex(index) {
      if (index || index == 0) {
        this.index = index
      } else {
        this.index = null
      }
    },
    // 返回布尔值
    beforeRead(file) {
      // console.log(file)
      const fileArr = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document']
      if (!fileArr.some((item) => { return file.type === item })) {
        Toast('请上传格式为 pdf/word 的文件')
        return false
      }
      return true
    },
    onOversize(file) {
      console.log(file)
      Toast('文件大小不能超过 10mb')
    },
    async uploadContractPictureFiles(file) {
      const _file = file.file
      // 通过 FormData 对象上传文件
      var formData = new FormData()
      formData.append('file', _file)

      await newContract.uploadContractFile(formData)
        .then((res) => {
          if (res.code === 200) {
            this.form.fileList[this.index].fileName = file.file.name
            this.form.fileList[this.index].url = res.url
            Toast.success(res.msg)
          } else {
            Toast.fail('res.msg')
          }
        })
        .catch(function (error) {
          console.error(error)
        })
    },
    addEnclosure() {
      const peo = {
        contractId: this.fixId || '',
        title: '',
        amount: '',
        fileType: '2',
        fileTypeName: '补充协议',
        fileDesc: '',
        url: ''
      }
      this.form.fileList.push(peo)
      const res = this.activeNamesC.some(item => {
        return this.form.fileList.length - 1 === item
      })
      if (res === false) {
        this.activeNamesC.push(this.form.fileList.length - 1)
      }
    },
    async deleteE(index) {
      if (this.form.fileList.length > 0) {
        this.form.fileList.splice(index, 1)
      }
    },
    addPoint() {
      this.form.pointList.push({
        percentage: '',
        useMoney: '',
        startTime: '',
        endTime: '',
        zxTime: ''
      })
      const res = this.activeNamesP.some(item => {
        return this.form.pointList.length - 1 === item
      })
      if (res === false) {
        this.activeNamesP.push(this.form.pointList.length - 1)
      }
    },
    deletePoint(index) {
      if (this.form.pointList.length > 0) {
        this.form.pointList.splice(index, 1)
      }
    },
    fixValue(val, index) {
      if (index == 1) {
        this.form.pointList[0].useMoney = val
      }
      if (Number(val) < Number(this.form.pointList[index - 1].useMoney)) {
        Toast.fail('当前金额不能小于上一个金额')
        this.form.pointList[index].useMoney = ''
      }
    },
    formatHandel(type, value) {
      const options = type + 'Options'
      if (value || value == 0) {
        return this.selectDictLabel(this.options[options], value)
      } else {
        return ''
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import url("@/style/index.less");
.editClue /deep/.van-dialog__content {
  height: 80%;
}
.tagArr{
  padding: 0px 10px 10px 10px;
  /deep/.van-tag{
    margin-left: 10px;
  }
}
/deep/.van-sidebar-item--select::before{
  background-color: #1989fa;
}
/deep/.van-tree-select__item--active {
    color: #1989fa;
}
.van-collaps-title{
  color: #1989fa;
}
.skzxkh{
  /deep/.van-collapse-item__content{
    padding: 10px 20px;
  }
}
.bottomBtn{
  display: flex;
  justify-content: space-around;
  /deep/.van-button--mini{
    width: 200px;
    padding: 24px !important;
  }
}
</style>
